import { SUBTEXT_COLOR } from "@/css/constants";
import { ComponentTypeEnum, RoleplayRank } from "@/graphql";

export const roleplayRankStyle: Record<
  RoleplayRank,
  {
    color: string;
    text: string;
    borderStyle: string;
    borderColor: string;
    textColor: string;
    rankIcon?: RoleplayRank;
    rankText?: string;
    rankValue: number;
  }
> = {
  [RoleplayRank.Bronze]: {
    color: "#DC7446",
    text: "Bronze",
    borderStyle: "solid",
    borderColor: "#DC7446",
    textColor: "#DC7446",
    rankIcon: RoleplayRank.Bronze,
    rankText: "Bronze",
    rankValue: 1,
  },
  [RoleplayRank.Silver]: {
    color: "#CBCBCB",
    text: "Silver",
    borderStyle: "solid",
    borderColor: "#CBCBCB",
    textColor: "#CBCBCB",
    rankIcon: RoleplayRank.Silver,
    rankText: "Silver",
    rankValue: 2,
  },
  [RoleplayRank.Gold]: {
    color: "#EDAF09",
    text: "Gold",
    borderStyle: "solid",
    borderColor: "#EDAF09",
    textColor: "#EDAF09",
    rankIcon: RoleplayRank.Gold,
    rankText: "Gold",
    rankValue: 3,
  },
  [RoleplayRank.Unranked]: {
    color: "transparent",
    text: "Unranked",
    borderStyle: "dashed",
    borderColor: "#BF7326",
    textColor: SUBTEXT_COLOR,
    rankIcon: RoleplayRank.Unranked,
    rankValue: 0,
  },
};

export const NO_RESPONSE_COMPONENT_TYPES = [
  ComponentTypeEnum.Announcement,
  ComponentTypeEnum.Video,
  ComponentTypeEnum.Article,
];
